module.exports = __webpack_public_path__ + "static/media/conversation_indicator.292235ee.png";